export default __webpack_public_path__ + "static/media/element_53.2fc9d063.avif";